/**
 * 邀请列表
 */

import React from 'react';
import styled from 'styled-components';
import map from 'lodash/map';

import { UiScroll } from '@/components';
import { hooks, request } from '@/lib';
import { room } from '@/modules/widgets/lib';

import ListItem from './list-item';

const StagePartyList = () => {
  const { data: list = [] } = hooks.useSimpleFetch(() =>
    request.funny.get('api/v1/multiRoom/war/guildRooms', {
      roomId: room.getRoomId(),
    }),
  );

  return (
    <Wrap overflowY>
      {map(list, (item) => (
        <ListItem isParty key={item.roomId} item={item} />
      ))}
    </Wrap>
  );
};

const Wrap = styled(UiScroll)`
  height: 580px;
  padding: 10px 24px;
`;

export default StagePartyList;
